import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import { TextField, Toolbar } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import Snackbar from "@mui/material/Snackbar";
import DialogContent from "@mui/material/DialogContent";
import Stack from "@mui/material/Stack";
// import { styled } from "@mui/material/styles";
import { useState } from "react";
import axios from "axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: "30px",
};

// const VisuallyHiddenInput = styled("input")({
//   clip: "rect(0 0 0 0)",
//   clipPath: "inset(50%)",
//   height: 1,
//   overflow: "hidden",
//   position: "absolute",
//   bottom: 0,
//   left: 0,
//   whiteSpace: "nowrap",
//   width: 1,
// });

export default function Category() {
  const [open, setOpen] = React.useState(false);
  const [snackbarState, setSnackbarState] = React.useState({
    open: false,
    vertical: "top",
    horizontal: "right",
  });

  const { vertical, horizontal } = snackbarState;

  const [catName, setCatName] = useState("");

  const handleOpen = () => setOpen(true);

  const handleClose = () => setOpen(false);

  const handleSnackbarClose = () => {
    setSnackbarState({ ...snackbarState, open: false });
  };

  const createCategory = (e) => {
    e.preventDefault();

    axios
      .post("https://tsetsegtuw.templateapi.xyz/categories", {
        catName: catName,
      })
      .then(() => {
        window.location.reload(false);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <Toolbar>
      <Button variant="contained" color="primary" onClick={handleOpen}>
        Бүлэг нэмэх
      </Button>
      <Modal
        sx={{ overflow: "scroll" }}
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <DialogTitle
            sx={{
              color: (theme) =>
                theme.palette.mode === "dark" ? "white" : "black",
            }}
          >
            Бүлэг нэмэх
            <IconButton onClick={handleClose} style={{ float: "right" }}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Stack spacing={4} margin={2}>
              <TextField
                variant="outlined"
                label="Гарчиг"
                value={catName}
                onChange={(e) => setCatName(e.target.value)}
                sx={{ width: "50%" }}
              />

              <Box display={"flex"} justifyContent="space-between">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={createCategory}
                >
                  Хадгалах
                </Button>
                <Button variant="contained" color="error" onClick={handleClose}>
                  Хаах
                </Button>
              </Box>
            </Stack>
          </DialogContent>
        </Box>
      </Modal>

      <Snackbar
        anchorOrigin={{
          horizontal: snackbarState.horizontal,
          vertical: snackbarState.vertical,
        }}
        open={snackbarState.open}
        onClose={handleSnackbarClose}
        message="Амжилттай хадгалагдлаа"
        key={vertical + horizontal}
      />
    </Toolbar>
  );
}
